/**
 * This script required fotorama and vimeo-frogaloop:
 * - Since fotorama requires jQuery we need to load it after the async app.js
 *   therefore we use loadJS()
 * - The rest is loaded via Carbon.IncludeAssets
 *
 * Vimeo-Froogaloop is already deprecated, see https://github.com/vimeo/player-api/
 */

(function () {
    var galleryElements = document.querySelectorAll('.gallery-wrapper');
    if (!galleryElements.length) {
        return;
    }

    function loadJS(u) {
        var r = document.getElementsByTagName("script")[0], s = document.createElement("script");
        s.src = u;
        r.parentNode.insertBefore(s, r);
    }

    loadJS('/_Resources/Static/Packages/CodeQ.Site/Frontend/web/js/fotorama.js');

    function waitForScript() {
        if (window.fotoramaVersion && window.Froogaloop) {
            onScriptLoaded();
        } else {
            setTimeout(waitForScript, 300);
        }
    }

    waitForScript();

    function onScriptLoaded() {
        var gallery = $('.gallery-wrapper');
        if (!gallery.length) {
            return;
        }

        // gallery page
        var imageRatio = 4 / 3,
            size,
            width,
            height;

        var calculateFotoramaSize = function () {
            width = gallery.width();
            height = gallery.height() - 68; // images are 63px high, navi in total 68px high
            if (width < 768) {
                // mobile
                return {
                    width: '100%',
                    height: false,
                    ratio: imageRatio
                };
            }
            return {
                width: width,
                height: height
            };
        };
        size = calculateFotoramaSize();

        var fotoramaEl = gallery.find('.fotorama-gallery');
        fotoramaEl.fotorama({
            width: size.width,
            height: size.height,
            ratio: size.ratio,
            glimpse: (width < 768) ? 0 : (width - imageRatio * height) / 2,
            nav: 'thumbs',
            hash: true,
            loop: true,
            keyboard: true,
            fit: 'contain',
            allowfullscreen: false,
            startindex: 1 // start with second image to not have a white space on the left when loading
        });

        var fotorama = fotoramaEl.data('fotorama');
        $(window).resize(function () {
            if (fotorama) { // only if there's a gallery on this page
                fotorama.resize(calculateFotoramaSize());
                fotorama.setOptions({
                    glimpse: (width < 768) ? 0 : (width - imageRatio * height) / 2,
                });
            }
        });


        // gallery video
        var vimeoId = '193573022';
        var video = false;
        var videoVisible = false;
        var close = $('<img src="/_Resources/Static/Packages/CodeQ.Site/Frontend/images/video-close-button.png">');
        close.css({
            position: 'fixed',
            'z-index': 999,
            top: 10,
            right: 40,
            width: 50,
            cursor: 'pointer'
        });
        var getPlayer = function () {
            getPlayer.player = getPlayer.player || {};

            // does the video already exist?
            if (getPlayer.player[vimeoId]) {
                return getPlayer.player[vimeoId];
            }

            //var video = $('<video class="hidden"><source src="/files/videos/Antonio_Interview_1.mp4" type="video/mp4" id="top-video"/></video>');
            var domId = 'vimeo-iframe-' + vimeoId;
            video = $('<iframe src="https://player.vimeo.com/video/' + vimeoId + '?api=1&amp;player_id=' + domId + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen class="fullscreen hidden"></iframe>');
            video.attr('id', domId);
            video.css({
                position: 'fixed',
                'z-index': 998,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
            });
            var body = $('body');
            body.append(video);
            body.append(close);

            // we are using Vimeo Froogaloop to get the event handling
            var player = $f(video[0]);
            player.addEvent('ready', function () {
                player.addEvent('finish', hideActiveInterviewPage);
            });
            getPlayer.player[vimeoId] = player;

            // on first opening, start playing when loaded
            video.on('load', function () {
                getPlayer().api('play');
            });

            return player;
        };


        var hideActiveInterviewPage = function () {
            if (!video) {
                return; // doesn't exist
            }

            close.hide();
            video.fadeOut();
            videoVisible = false;
            getPlayer().api('unload');

            // hide fullscreen
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        };

        close.click(hideActiveInterviewPage);

        // currently this only works for desktop
        $('body').on('click tap touch touchstart', 'img.fotorama__img', function (e) {
            if ($(this).attr('src').indexOf('video-teaser') === -1) {
                return;//console.info('abort');
            }
            if ($(this).parent().is('.fotorama__thumb')) {
                // clicking the navigation thumb also should not open the video
                return;
            }
            e.preventDefault();
            e.stopPropagation();

            // revert the fotorama next click
            if (!$(document.body).hasClass("mobile")) {
                $(this).parents('.fotorama-gallery').data('fotorama').show('<');
            }

            getPlayer();
            video.show();
            close.show();
            videoVisible = true;
            getPlayer().api('play'); // this will currently not work in iPad, since it's not a "real" user interaction
            setTimeout(function () {
                getPlayer().api('play');
            }, 100);

            // open fullscreen
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) {
                document.documentElement.msRequestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        });
    }
})();
